module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter003"
    }
  }), _vm._v("THREE")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "line2",
      "src": "images/line2.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("CORSETED")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he wedding celebration continued for nine more days and nights, with gambling in the Hall of Mirrors, dancing in the ballroom, and banqueting, opera, and ballet in Gabriel’s "), _c('em', [_vm._v("salle de spectacles")]), _vm._v(". On the festivities’ final evening, Louis XV launched a fireworks display—postponed from the first night because of heavy rains—by flinging a flaming spear from an open window in the Hall of Mirrors."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en1ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The spectacle involved a volcanic eruption of fireworks over the palace gardens’ Temple of the Sun, and culminated in the simultaneous detonation of twenty thousand rockets that crashed through the darkness like falling stars."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en2ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Afterward, 200,000 revelers in the castle’s gardens spent the night dancing alongside the reflecting pool and fountain known as Apollo’s Basin. Illuminated by scores of multicolored lanterns, the trellises, allées, archways, and obelisks that encircled the basin were reported as being “far more brilliant than when lit by the sun in all its splendor, [and outstripped] everything that one reads of Fairyland.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en3ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the festivities’ guest of honor and its animating spirit, Marie Antoinette sparkled just as brilliantly as the Fairyland that had been created in her honor. To a certain extent, that sparkle was literal: on her wedding day, Louis XV had presented her with the coffer of jewels that tradition reserved for the Dauphine of France. Covered in richly embroidered crimson velvet, the coffer was nearly as tall and three times as wide as its new owner, whose hands shook with excitement as she unlocked it with a tiny golden key."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en4ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Inside, glittering on the robin’s-egg-blue silk lining, she found a magnificent array of necklaces and earrings, fans and snuffboxes, bracelets and buttons—corseted "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("all glittering with diamonds and other precious gemstones, and valued collectively at almost 2 million livres."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en5ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" One of the collection’s most stunning pieces was a necklace of priceless oversized pearls first worn in the seventeenth century by Louis XIV’s mother, Anne of Austria, an ancestress Marie Antoinette happened to share with her bridegroom. Along with the set of splendid white diamonds she had brought with her from the Hofburg as part of her trousseau, these treasures became additional ornaments for the Dauphine’s already resplendent court costumes. Even among a sea of courtiers “clad in brocades, silks, and other gorgeous robes, [and] flashing with jewels,” the Austrian newcomer shone the brightest."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en6ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A handful of the more critical wedding guests remarked that the girl’s frame seemed far too slight to support such a hefty abundance of gems."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en7ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Nonetheless, in a palace where a trim torso was de rigueur, universally enforced through the adoption of whalebone stays, the girl’s very delicateness redounded to her credit, as did her fair hair, wide blue eyes, and already much touted alabaster complexion."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en8ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Royal marriages always spawned tributes to the bride’s physical charms, whether or not she actually deserved them, but in Marie Antoinette’s case, the poets’ encomia did not seem far off the mark. So “luminous and fragile” did she appear, according to her new lady-in-waiting, Mademoiselle de Mirecourt, that “we dreamed we were watching Spring incarnate.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en9ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her bearing provided viewers with additional grounds for approval, for, in Madame Campan’s words, it was “simultaneously graceful and imposing.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en10ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" By most accounts, her posture was indeed perfect, and she had a way of carrying her head that, her contemporaries agreed, marked her as a queen even in a room full of other great ladies."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en11ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Of course, Marie Antoinette had worked slavishly to win this acclaim: it had taken hours of training with Noverre before she could perform the “Versailles glide” without a misstep. Moving in such an airy, effortless fashion was no mean feat under the best of circumstances, much less among the profusion of obstacles littering the floors of the Bourbon court. Cleanliness did not feature heavily inside the palace, and those navigating its passageways had to steer clear of everything from the feces of palace pets to scraps of food dropped by careless servants to mud tracked in by peddlers and tourists. The long, cumbersome gowns of the formally attired court ladies also posed problems; the folds of a noblewoman’s train—which, the courtier and noted writer Madame de Genlis complained, was always “of immoderate length”—tended to snag at the heels of nearby ladies’ slippers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en12ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Accidental contact caused severe mortification for everyone involved. But for Marie Antoinette, it was as if these pitfalls didn’t exist: “she walked as if on wings.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en13ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("She danced more elegantly still. On May 19, the Dauphine and her husband were called upon to perform the first minuet at a dress ball held in the great, gilded "), _c('em', [_vm._v("salle de spectacles")]), _vm._v(". Encircled by several thousand lookers-on, the heir to the throne shuffled through the dance in obvious discomfort, blushing and scowling in his usual unappealing way. His bride, by contrast, seemed only to become more graceful as the music played on, and in a world where the Bourbons’ physical splendor was supposed to mirror their political supremacy, such easy elegance made a strong impression. During her début minuet, her movements were reportedly “so natural and so graceful that the immense hall was filled with nothing but murmurs of admiration.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en14ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Insofar as they augured good things for the Franco-Austrian alliance, the Dauphine’s public triumphs met with the approbation of both Louis XV and Maria Theresa, who had instructed her ambassador Mercy to send her regular dispatches about the girl’s doings—dispatches that were to be kept secret from everyone at Versailles, including Marie Antoinette herself. “Our archduchess has surpassed all my hopes,” Mercy informed the Empress shortly after the wedding. “The whole court and the general public are full of nothing but praise for her.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en15ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Louis XV in particular, he added, “remains very satisfied with Madame la Dauphine, and is always caressing and complimenting her in a very graceful and touching way.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en16ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Maria Theresa in turn wrote to her daughter to commend her for having “captured everyone’s hearts,” and reminded her that the King’s heart was especially important quarry. She enjoined Marie Antoinette to “love him, obey him, try to anticipate his thoughts; you cannot do too much [on that front].”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en17ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marie Antoinette took this advice to heart, flirting prettily with Louis XV every chance she got, and calling him her “dear Grandpapa” in defiance of more formal rules of address."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en18ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" To ingratiate herself further, she informed him that she “would be charmed to accompany him on the little voyages he had a habit of making” to his nearby residences at Choisy and Compiègne, Meudon and Fontainebleau—trips that usually featured regular hunting expeditions with the Dauphin, and in which the King readily included her."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en19ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" (Marie Antoinette did not yet ride well enough to participate in these outings on horseback, so she followed the princes and their fellow hunters from the safety of an elegantly appointed calèche.) Although also something of a novice with a needle and thread, the Dauphine proudly announced her plan to embroider a vest for Louis XV and made winningly self-effacing little jokes about how long the project was taking her: “I hope that with the grace of God it will be finished in a few years.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en20ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" When she extended this deadline to twenty years, her “dear Grandpapa” laughed and told her she should really try to complete the vest before he died. Even the girl’s sewing mistakes drew indulgent smiles from the jaded old monarch.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('img', {
    attrs: {
      "alt": "common",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MARIE ANTOINETTE WAS RIGHT TO HEED HER MOTHER’S COUNSEL IN CULTI")]), _vm._v("vating Louis XV’s affections, because for her as for the other members of his court, all blessings flowed from him and him alone. As a result, competition for the King’s favor created an atmosphere of bitter acrimony and infighting at the château."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en21ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" A scandalized Mercy described the French court to his Empress as an “abode of treachery, hatred, and revenge . . . , [fueled] by intrigues and inspired by personal interest.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en22ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" And while Marie Antoinette’s exalted position alone sufficed to earn the jealousy of those thousands of less fortunate courtiers striving for advancement, her special rapport with Louis XV made her particularly unpopular with the members of the French party, for whom each of the Dauphine’s little victories scored points not just for her, but for Austria and Choiseul."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en23ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mesdames the Aunts remained at the forefront of this hostile group, but their long years at Versailles had taught them the importance of dissimulation and tact. Jean de La Bruyère, the great moralist of seventeenth-century Versailles, had written: “Do not ever hope for candor, frankness, fairness, . . . benevolence or generosity from a person who has spent any time at court,” and Louis XV’s daughters had learned this lesson well."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en24ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" They had little trouble concealing their animosity from the girl—despite the fact that etiquette obliged Marie Antoinette to spend hours every day in their company, from visits to their apartments each morning to obligatory card games at night. In her presence, the older women behaved sweetly enough; but behind her back, they railed against the girl they dubbed "), _c('em', [_vm._v("l’Autrichienne."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en25"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en25ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In their effort to win their niece’s trust, the Aunts benefited from the fact that she had always taken orders from a strong older woman—Maria Theresa, who, in the letter Marie Antoinette had retrieved at Freiburg, had explicitly ordered her daughter to follow Mesdames’ lead in adapting to life at Versailles. With their veneer of piety and the august rank they enjoyed as Children of France, the sisters seemed to the Empress the most trustworthy mentors their new niece could hope to find. And this was precisely how they presented themselves to the Dauphine. They even gave her a key to their apartments, to encourage informal as well as formal visits. Such increased intimacy would enable them to gather valuable information against Marie Antoinette, information they could use to undermine her in the King’s eyes. By adopting them as her surrogate mothers, the unsuspecting princess would make their job that much easier."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en26"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en26ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Aunts and their coterie of stodgy (if vindictive) friends were not the only ones who blanched to see the Dauphine dazzle. On the opposite end of the court’s social spectrum, the wanton and beautiful Comtesse Du Barry, "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("herself a longtime victim of Mesdames’ vicious prattle, shared the older women’s antipathy to Marie Antoinette. The rambunctious, impudent, lowborn royal mistress differed from Mesdames and their pious cronies in just about every way, except in the hatred that she, too, bore the Duc de Choiseul. Seconded by those in his cabal, the foreign minister incensed the Comtesse not only by crowing at having brought the girl to France, but by commenting pointedly on her obvious superiority to all the court’s other noted beauties."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en27"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en27ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With her striking combination of pale blond curls and sultry, violet-colored eyes, Du Barry was unaccustomed to competition from other women at court. (“You are the King’s divinity,” the legendarily lusty Duc de Richelieu was fond of reminding her."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en28"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en28ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(") By the same token, she was aware that her lover bored easily. Like her predecessor Pompadour, Madame Du Barry had thus, in the words of one court memorialist, built her career on “dissipating his ennui by every means possible.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en29"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en29ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" She organized licentious private parties for Louis XV and his friends, behaved with a saucy vulgarity that her lover found titillating, and shared with him the latest, illicitly published satirical verses and pornography (even when such publications took aim at her personally). The favorite’s "), _c('em', [_vm._v("choiseuliste")]), _vm._v(" detractors maintained that she actually went so far as to place other young lovelies in the King’s bed, so that she might control him even when he strayed from her side. His interest in Marie Antoinette, though, was something the Comtesse could not control, and so posed a notable threat to her position. Behind closed doors, palace gossips gave voice to Du Barry’s worst fear: that before long, the old roué would look to his own granddaughter-in-law for a piquant change of pace."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en30"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en30ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adding insult to injury, the princess soon adopted the "), _c('em', [_vm._v("choiseulistes")]), _vm._v("’ habit of treating Madame Du Barry with open disdain. The favorite did not know it, but Marie Antoinette’s coldness was the handiwork of the Aunts, who had exultantly filled their nephew’s wife in on Du Barry’s scandalous past."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en31"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en31ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Born Jeanne Bécu, the favorite was the illegitimate daughter of a promiscuous seamstress and a badly behaving monk. After a few years of education in a convent, she took a job as a shopgirl in a fashionable Parisian accessories store, but found a more lucrative sideline in a series of brothels, where she charged 24 livres for a night of love."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en32"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en32ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" It was in this milieu—which Jeanne herself later flippantly described as her “Seminary of Debauch”—that the young prostitute became involved with an aristocratic but cash-strapped libertine named Du Barry."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en33"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en33ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" When her new lover brought her into Louis XV’s sights, he realized he stood to win the King’s favor (and thereby resolve his own financial difficulties) by installing her as the newest "), _c('em', [_vm._v("maîtresse en titre")]), _vm._v(". This was in 1768, four years after Madame de Pompadour’s death, and although the King had been deeply afflicted by his trusted mistress’s passing, his well-known sexual appetites made it highly unlikely that her post would remain vacant forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("Acting fast, Du Barry arranged a marriage of convenience between the fifteen-year-old Jeanne and his brother, the Comte Du Barry, with Jeanne’s own father officiating at the ceremony. The farce endowed Jeanne with an aristocratic title, and thus qualified her to receive the King’s official attentions. Mesmerized by her beauty, which even the worldliest of noblemen concurred in finding “celestial,” Louis XV eagerly installed her in Pompadour’s place."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en34"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en34ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" In April 1769, he arranged for her formal presentation at court—a ceremony usually reserved for the flower of the nobility—where the former shopgirl and prostitute shocked the world by mincing in among her betters with a hundred thousand livres’ worth of jewelry on her person, and diamonds on the soles of her shoes."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en35"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en35ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" But the King’s courtiers weren’t the only ones who recoiled to see a lowly tramp rise so high. Thanks in part to the efforts of the "), _c('em', [_vm._v("choiseulistes")]), _vm._v(", who funded the publication of underground pamphlets about Du Barry’s lubricious exploits (real and exaggerated), French commoners also became outraged at her ascendancy."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en36"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en36ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" From the salons of Versailles to the streets of Paris, malcontents complained that Louis XV’s new favorite would turn the very throne room into a Seminary of Debauch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the Aunts, passing such gossip on to Marie Antoinette had two related advantages. First, it would help them instill in the girl such a hearty aversion toward the Comtesse that Du Barry would face social humiliations beyond any she had previously known. Second, and more important, they seem to have hoped that the Dauphine’s inevitable dislike of the favorite would get her into serious trouble with Louis XV."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en37"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en37ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Too naïve to detect this double game, Marie Antoinette played right into Mesdames’ hands. Having received a fairly strict religious upbringing, she was obligingly horrified by the details of Madame Du Barry’s salacious history and concluded that it would be indecent for her to acknowledge the favorite’s existence."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en38"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en38ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" In one letter to Maria Theresa, she justified her conduct by describing the King’s lover as “the stupidest and most impertinent creature imaginable”—and this was not an opinion she felt compelled to confine to the printed page."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en39"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en39ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Whenever she encountered “the creature,” the Dauphine’s naturally haughty-looking lower lip—which the Cardinal de Rohan had already noticed at Strasbourg as being “scarlet as a cherry, but thick . . . , which one knows is the distinctive trace” of the Hapsburgs, curled into an unmistakable sneer."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en40"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en40ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" She refused to address so much as a word in the favorite’s direction, even when the King was looking on. Much to the Austrian ambassador’s dismay (for Mercy realized that no good could come of snubbing the King’s mistress), the Dauphine “made frequent jokes in public” at Du Barry’s expense."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en41"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en41ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Laughing at these witticisms for reasons their young "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("niece did not suspect, the Aunts encouraged her in the erroneous belief that hers was the course of righteousness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given her influence on the King, Du Barry’s enmity could prove lethal to the already friendless Dauphine. The Aunts recognized, however, that it would take a more flagrant scandal to turn their father against the girl in earnest, for his propensity toward boredom and his sexual profligacy were not his only defining qualities. Another, his daughters knew as well as anyone, was a peculiar apathy that their enemy Choiseul once described as a “total inertia of the soul.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en42"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en42ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Louis XV excelled at making hot chocolate and prided himself on his knack for cutting the top off a boiled egg with one neat swipe of his spoon."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en43"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en43ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Apart from these talents, his sexual romps, and his passion for the hunt, very little interested him enough to rouse him from his indolence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So the Aunts bided their time as, humiliated by the Archduchess’s public slights, Du Barry retaliated by criticizing the girl sharply and frequently, and by sharing her views with “all those whose political ambitions had been thwarted, hurt, humiliated by Choiseul’s ministry.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en44"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en44ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" This group included not only the Duc d’Aiguillon, widely believed to be Du Barry’s secret lover, but also the Duc de La Vauguyon, a singularly mean-spirited man whose chief claim to fame had been serving as Louis Auguste’s boyhood tutor. Having worked actively to establish Du Barry as the King’s favorite, the two "), _c('em', [_vm._v("barryste")]), _vm._v(" ringleaders did not appreciate seeing her power diluted—by Choiseul’s protégée, no less—and they joined the favorite in running down the Dauphine whenever the King was within earshot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps most notably, to neutralize the slew of compliments the Austrian princess had garnered for her elegance and beauty, the "), _c('em', [_vm._v("barryste")]), _vm._v(" crew referred to her as “that little redhead” (red hair being infinitely less desirable than Du Barry’s own much admired blond), and pronounced with mock regret that the Dauphine “had no figure to speak of.” Not surprisingly, the favorite’s verdict was harshest of all: “I see nothing attractive in red hair, thick lips, sandy complexion, and eyes without eyelashes,” she sulkily informed Louis XV. “Had she who is so beautiful not sprung from the House of Austria, such attractions would never have been the subject of admiration.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en45"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en45ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" In a court where appearance was everything, these were fighting words, and like all gossip at Versailles, they quickly became fodder for widespread discussion. First making the rounds of the Oeil-de-Boeuf (the heavily trafficked antechamber outside the King’s apartments, named for its “bull’s-eye”-shaped window), the slurs quickly spread throughout the palace. But to the joy of both wings of the French party, it soon became apparent that caustic assessments of the girl’s looks were not the only ammunition they had at their disposal.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('img', {
    attrs: {
      "alt": "common",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN HER FIRST FEW MONTHS AT VERSAILLES, THE DAUPHINE REMAINED LARGELY")]), _vm._v(" ignorant of these intrigues, as she was distracted by a different problem, one that had the whole of the court chattering about the state of her marriage. Aristocrats whispered about it in out-of-the-way salons and allées."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en46"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en46ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Servants mulled it over in the stables and the vegetable gardens. Visiting diplomats described it in their eagerly awaited dispatches to princes back home. Choiseul assessed the situation by declaring with characteristic bluntness: “unless [the Dauphin] changes, he will end by becoming the horror of the nation,” a pronouncement by which Louis XV said he was “moved very deeply,” though the sovereign also expressed hope that the worrisome circumstances would improve “when we least expect it.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en47"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en47ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Maria Theresa adopted a similarly optimistic stance when she chalked the issue up to her new son-in-law’s “extreme youth and shyness.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en48"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en48ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Marie Antoinette, for her part, ventured no such opinions or theories, but simply reported the facts to her tutor, the Abbé de Vermond. Paraphrasing her remarks to the Empress’s emissary, Starhemberg, Vermond recorded that “since the occasion of their meeting in the forest of Compiègne, Monsieur le Dauphin had not only not kissed her, but had not even touched her hand.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en49"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en49ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Louis Auguste, in short, had still made no effort to consummate his marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to a medical expert whom Maria Theresa consulted on the matter, this qualified as “strange behavior,” even though the fifteen-year-old Dauphin was indeed, as the Empress had put it, still quite young, and even though the timidity she had accused him of was indisputably one of his most marked character traits."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en50"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en50ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Orphaned at the age of thirteen, both of his parents having died of tuberculosis, Louis Auguste had grown up under the more or less exclusive tutelage of the Duc de La Vauguyon, who had kept him isolated from other courtiers on the grounds that as a Bourbon prince, he was superior to them all. According to one critical contemporary, the greatest legacy of the boy’s lonely upbringing was a “dread [of] conversation and [a] shyness so deeply rooted in [his] soul that it was impossible to cure” him."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en51"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en51ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" In addition, La Vauguyon had instilled his pupil with a profound suspicion of Choiseul and the House of Austria—a sentiment that Louis Auguste’s late father, Louis Ferdinand, one of the foreign minister’s most implacable enemies, had fervently shared."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en52"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en52ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Between his antisocial character and his ingrained Austrophobia, it was thus perhaps not altogether startling that Louis Auguste should panic when confronted with the gregarious and attractive female emissary of the "), _c('em', [_vm._v("choiseuliste")]), _vm._v(" alliance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even so, in the context of a royal union, sex was a nonnegotiable duty, and all the more so in France at that particular time. Under the kingdom’s previous "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("two sovereigns, Louis XIV and Louis XV, the immediate heirs to the throne had met with untimely deaths, leading to worrisome generation gaps in the succession. Louis XV, great-grandson to the Sun King, had acceded to the throne at age five, after the deaths of his grandfather, father, and two older brothers, while Louis Auguste had lost two older brothers as well as his father before becoming Dauphin. Even with two younger brothers waiting in the wings—the Comte de Provence, aged fourteen, and the Comte d’Artois, aged thirteen, both slated to marry within the next few years—Louis Auguste had his work cut out for him. He and the Dauphine needed to start a family, without delay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet delay Louis Auguste did, leaving both partisans and enemies of the Austrian alliance obsessively to monitor what Madame Campan called his undiminished “indifference and coldness”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en53"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en53ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" toward his wife. Etiquette required that he dine with Marie Antoinette in public and join her and the rest of the royal family for daily gatherings in the Aunts’ apartments. But when not at these command performances, the young man fled his bride with the terrified haste of a man swarmed by bees. He devoted his days to the hobbies that had filled his bachelorhood: hunting in the parks around the royal residences, and tinkering with locks and clocks in his private workshop, under the tutelage of a gruff professional smith named François Gamain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both pastimes excluded Marie Antoinette. Her inexperience as an equestrienne barred her from participating fully in her husband’s beloved hunting jaunts; and she herself dismissed the idea of joining him in his smithy, on the grounds that she would be as incongruous there as “Venus at Vulcan’s forge.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en54"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en54ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Here again, the princess found in classical literature an apt point of reference for her own life: Venus, the comely goddess of love, and Vulcan, the malformed blacksmith god, were among mythology’s most improbable—and most unhappy—married couples. Stubbornly absorbed in his rough-and-tumble pursuits, Louis Auguste appeared all too willing to hold up his end of the analogy, leaving Marie Antoinette as pure and untouched as the painted images of Venus that gamboled across her bedroom walls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor did the Dauphin’s aloofness abate after dark. Instead of visiting his wife in her chambers, as princes with a dynastic mission were expected to do, Louis Auguste elected to spend most evenings in his own rooms, where he tried to deflect his attendants’ inquiring stares with bizarre, infantile antics. For the ceremonial preparations he had to undergo before bed each evening, he developed a favorite prank involving the blue sash he wore over his coat as a mark of his adherence to the Order of the Holy Spirit. As his gentlemen attempted to remove his clothing, the Dauphin would grab the sash with both hands, wave it in the air like a lasso, and attempt to loop it through the earring of a nearby courtier or valet. If the sash reached its target, he would then proceed to rip the man’s earlobe with a swift, gleeful tug."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en55"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en55ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v("Such outbursts made it difficult, if not downright impossible, for the assembled crew to perform their prescribed functions—removing his coat and shoes, putting slippers on his feet, changing him into his nightgown, tucking his hair into a nightcap—with anything resembling gravity or ease. Like all other princely rituals, the "), _c('em', [_vm._v("coucher")]), _vm._v(" was supposed to affirm both the Bourbon family’s dignity and the courtiers’ own prestigious role in upholding it. By behaving in a manner that belied the nobility of his station and compromised his attendants’ ability to serve him, Louis Auguste compounded the scandal emanating from his other “strange behavior.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MEANWHILE, THE YOUNG MAN’S RETICENCE IN THE BEDROOM WAS MAKING")]), _vm._v(" it downright impossible for Marie Antoinette to be, as the elderly "), _c('em', [_vm._v("salonnière Madame")]), _vm._v(" du Deffand put it, “a real dauphine.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en56"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en56ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" But according to Maria Theresa, Louis Auguste’s evasions did not relieve the Dauphine of her own marital obligations. Marie Antoinette, the Empress declared in her regular missives to France, could not content herself with charming Louis XV; she must also please her husband, and clinch the Franco-Austrian alliance by giving birth to a royal heir. “Everything depends on the wife,” the Empress proclaimed, “on her being compliant, sweet, and amusing” toward her husband: a consort’s “only business [must be] to please and obey” her man."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en57"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en57ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Having governed a vast empire while her own husband amused himself with horses and mistresses, Maria Theresa herself had not exactly lived by this advice. But for her daughter, she seemed to envision a more traditional path, directing the girl to combat the Dauphin’s reserve with gentle but prodigious “caresses and cajoling.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en58"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en58ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young woman responded by declaring to her mother and anyone else who saw fit to inquire “that she was trying to win [Monsieur le Dauphin]’s confidence, and that she hoped to succeed in this.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en59"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en59ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" She seems to have intuited that this reluctant future king suffered from a debilitating sense of his unsuitability for the role, especially when compared with the dashing Louis XV."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en60"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en60ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Compassionately, Marie Antoinette tried to bolster the boy’s low self-esteem by announcing both in and outside of his company that she found him “more and more loveable each day.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en61"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en61ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" With the King’s permission, she began taking riding lessons on a donkey, so that she might one day be able to follow the royal hunt. She acted as peacemaker in the bitter fights Louis Auguste had a habit of getting into with his middle brother, the Comte de Provence, who mocked him cruelly for his clumsiness and lack of wit. And whenever she caught her husband emerging from his workshop, she extended her pretty white hands to him in an affectionate greeting, pretending not to notice how badly his own hands had been blackened by the forge."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en62"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en62ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v("Where other courtiers looked upon him with barely disguised impatience or scorn, Marie Antoinette welcomed him with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, for the first few months of the marriage, the Dauphine’s overtures had little discernible impact. Apart from hunting and smithing, the only topic Louis Auguste appeared willing to broach with his wife was their latest meal. As a rule, he consumed vast amounts of food each time he sat down to eat—downing at least “four cutlets, a chicken, a plateful of ham, half a dozen eggs in sauce, and a bottle and a half of champagne [in the mornings] before setting out to hunt.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en63"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en63ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Often these excesses drove him to serious bouts of indigestion, during which she cheerfully stayed by his side to tend to him."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en64"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en64ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Yet despite his frequent digestive troubles, the Dauphin returned ceaselessly to the same topic: the cooks were not feeding him enough. Trying to be as “sweet, compliant, and amusing” as her mother had commanded, his wife fielded these complaints with an empathetic air. Still, neither their tone nor their content was at all conducive to romantic intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the court embarked upon its annual summertime tour of the King’s smaller châteaux in the region around Versailles, Marie Antoinette tried a different tack. One Sunday in July, while the court was at Choisy, she detained the Dauphin alone and confronted him directly about their sex life. “Since we must live in intimate friendship,” she explained, “we must trust one another in speaking frankly about everything.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en65"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en65ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" For all his shyness, her husband seemed grateful that she had raised the subject, and said that he shared her point of view. As Marie Antoinette later reported to Mercy, the Dauphin professed “that he was not ignorant of what was involved in the state of marriage, that from the beginning he had hatched a plan from which he had not wanted to deviate, and that once the court traveled from Choisy to [the royal residence at] Compiègne in August, he would live with her in the intimacy that their union required.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en66"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en66ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" More specifically, Louis Auguste promised her that when he turned sixteen (his birthday would coincide with the visit to Compiègne), “all would be accomplished,” and that he would visit her bedroom more frequently thereafter."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en67"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en67ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Like Versailles, Choisy was no place to keep a secret, and the château soon buzzed with news of a rapprochement. All signs seemed to point toward a happy resolution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the signs were misleading. For reasons Louis Auguste either did not know or did not care to explain, his sixteenth birthday came and went with no change whatsoever in the status quo. On a sporadic basis, the Dauphin might show up in Marie Antoinette’s rooms—only to have his courage fail him. During these visits, Madame Campan recorded, the youth would simply crawl into bed without speaking to or touching his wife, and the next morning, he would try to sneak out while Marie Antoinette was still in slumber."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en68"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en68ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" But more often, he left his wife to spend the night alone. By the "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v("summer’s end, the scene that greeted the ladies who waited upon the Dauphine each morning was invariably the same as it had been back in May. Drawing back the curtains on the immense four-poster, they would find the girl all by herself, clinging pitifully to her little pug. Prince Starhemberg and Mercy had had Mops sent back to her from Vienna as a concession to the Dauphine’s loneliness."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en69"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en69ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOR THE DAUPHINE WAS LONELY INDEED, ALTHOUGH SHE WAS ALMOST")]), _vm._v(" never alone. Whereas in Vienna, she had spent her days frolicking with her many brothers and sisters, she was now, like her husband, surrounded at all times by a large, official entourage."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en70"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en70ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" Handpicked by the King, the group was presided over by Marie Antoinette’s "), _c('em', [_vm._v("dame d’honneur")]), _vm._v(", Madame de Noailles, and the Mistress of the Robes "), _c('em', [_vm._v("(dame d’atours)")]), _vm._v(", the Duchesse de Cossé-Brissac (whose husband had secured her the post through his close ties to none other than Madame Du Barry). Serving alongside these ladies were twelve noblewomen whose principal function was to accompany their mistress everywhere "), _c('em', [_vm._v("(dames pour accompagner Madame la Dauphine")]), _vm._v(", known after her accession as "), _c('em', [_vm._v("dames du palais de la Reine)")]), _vm._v(". Like the "), _c('em', [_vm._v("dames d’honneur")]), _vm._v(" and "), _c('em', [_vm._v("d’atours")]), _vm._v(", these women’s positions were known as "), _c('em', [_vm._v("charges d’honneur")]), _vm._v(", bestowed as a function of their families’ exalted lineage and court connections. "), _c('em', [_vm._v("Charges")]), _vm._v(" at this level carried with them substantial pensions and, because they allowed for unequaled access to the future queen, unquantifiable, priceless prestige.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serving beneath the "), _c('em', [_vm._v("dames")]), _vm._v(" were sixteen Women of the Bedchamber "), _c('em', [_vm._v("(femmes de chambre)")]), _vm._v(", recruited from the ranks of the local haute bourgeoisie. “The first four [of these women] performed their service by twos, for alternate fortnights, replaced in emergencies by their deputies among the twelve under-women.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en71"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en71ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" (It was to this group that Madame Campan—whose father-in-law served as Marie Antoinette’s personal librarian—proudly belonged.) The "), _c('em', [_vm._v("femmes de chambre")]), _vm._v(" in turn relied on the assistance of a cadre of "), _c('em', [_vm._v("femmes rouges")]), _vm._v(" or “red women,” so called because of the distinctive red uniform they wore to perform their duties."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en72"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en72ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marie Antoinette also had a hundred officers and valets to manage her finances and run her household, two hundred servants to oversee the preparation and service of her meals, and a small cadre of priests to tend to her spiritual needs. Against her enemies’ wishes, the tutor whom Choiseul had assigned to Marie Antoinette while still in Austria, the Abbé de Vermond, had been permitted to follow her to Versailles to continue her studies. “Six equerries, nine ushers, two doctors, four surgeons, a clock-maker, a tapestry-maker, eighteen lackeys, a fencing master, and two muleteers” "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("rounded out the picture."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en73"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en73ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Like Marie Antoinette’s ladies, these staffers shared a single objective: to serve the future Queen of France, upon whose benefaction their livelihood depended. Beset on all sides by their zealous ministrations, Marie Antoinette soon found she “could not make a gesture, take a step, utter a word without triggering a reaction in the attendants who never left her.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en74"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en74ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whereas she had grown up in a court marked by at least occasional lapses into bourgeois informality and comfort, Marie Antoinette was now treated with the unremitting solemnity accorded to all Bourbons under Louis XIV’s system of etiquette. As Madame Campan observed, the protocol to which the princess was forced to adhere turned her into both an idol and a victim: an idol because her entourage had to worship her like a goddess, but a victim because their staunch service robbed her of whatever privacy she had enjoyed in Vienna."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en75"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en75ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Indeed, in the seventeenth century, the court moralist La Bruyère had expressed this paradox in much the same way when he asserted that at Versailles, “kings want for nothing except the pleasures of a private existence.” This was certainly true for the young dauphine."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en76"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en76ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even at her bath time, Marie Antoinette found she could not escape her retinue, though she tried to preserve what Madame Campan described as her “excessive sense of modesty” and privacy by wearing a long cotton gown into the bathtub itself."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en77"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en77ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" Such gestures, however, presented a flimsy defense against her courtiers’ avid stares. Undergoing this awkward experience day after day—for unlike her French compatriots, the Dauphine evinced a “Germanic” devotion to regular baths—she was repeatedly confronted with the truth of her mother’s maxim: “All eyes will be fixed on you.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en78"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en78ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" Her body, she was learning, was most definitely not her own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This drastic shift from her old way of living left the Dauphine tremendously nostalgic for Austria: “I swear to you,” she wrote to her mother in July, “that I have not received one of your dear letters without having tears come to my eyes. . . . I ardently wish I could see my dear, my very dear, family for at least one more instant.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en79"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en79ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" And in another missive, she confessed forlornly: “My heart is always with my family in Austria.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en80"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en80ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" These proclamations may have stemmed more from homesickness than from outright filial affection—years later, Marie Antoinette would admit that she “feared [Maria Theresa] more than she loved her”—but still, the girl’s sense of isolation seems to have been acute."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en81"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en81ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" The Abbé de Vermond, who was just about the only familiar face Marie Antoinette encountered in her new household, detected “moments of sadness” beneath the sunny demeanor she tried to maintain in public."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en82"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en82ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" “My heart,” Vermond admitted to one Maria Theresa’s closest advisers, “is absolutely wrung by all this.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en83"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en83ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("Initially, the Dauphine tried to make the best of the situation by cultivating friendships with the ladies who flanked her night and day. Though the majority of these women were far older than she, and not prone to spontaneous fits of hilarity, Marie Antoinette was thrilled to discover among some of her younger "), _c('em', [_vm._v("dames")]), _vm._v(" and their friends a spirit of merriment not unlike the one she had been given to indulging with her brothers and sisters back home. These newfound companions of hers, noted one contemporary,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("loved pleasure and hated restraint, laughed at everything, even the tattle about their own reputations, and recognized no law save the necessity of spending their lives in gaiety, behind a thin and sometimes deceptive screen of decorum, which concealed badly, or not at all, certain caprices which came near to creating scandal."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en84"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en84ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marie Antoinette’s capers with this group ranged from chasing butterflies in the palace gardens to going for donkey rides in the forests around Versailles. Above all, though, her new chums encouraged her in making fun of the absurd characters who abounded at court. Among their favorite targets were the grotesquely dowdy, laughably self-important ladies of the older generation. Looking like creatures from another century (often their ceremonial court costume was just about that old), these women became known in the Dauphine’s irreverent circle as “turned-up collars,” “packages,” and “centuries.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en85"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en85ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Failing to grasp these elders’ importance as tireless purveyors of gossip and strict arbiters of politesse, Marie Antoinette dismissed them out of hand. “When one has passed the age of thirty, I don’t know how one dares show oneself at [Versailles],” she sniffed."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en86"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en86ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" Though the remark won her many unseen enemies among the palace’s éminences grises, even within her own retinue, her young friends laughed and laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a similarly ill-advised manner, the Dauphine also enlisted her clique to join her in mocking Madame Du Barry, whose infantile lisp lent itself to parody and whose crude way of speaking and eating betrayed her lowly origins. Pompous despite her unimpressive background, the favorite had fifty footmen in her service and insisted upon being accompanied everywhere by “an exotic Bengali page [named] Zamor, who strutted along behind her in a pink velvet jacket and trousers, a white turban wound around his head, a small sword at his side.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en87"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en87ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Madame Du Barry’s Blenheim spaniel, Dorine, boasted a similarly outrageous getup: a diamond-and-ruby-studded collar and leash, gifts from the King of Sweden."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en88"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en88ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" Sometimes the Comtesse pushed her whims to insulting extremes, as for instance when she forced a visiting papal nuncio to bring her shoes to her while she luxuriated, half-dressed, in her bed."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en89"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en89ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" Certainly, the money that Louis XV lavished upon her enabled her "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v("to dress like a queen—she had an income of 150,000 livres a year—and she spent it with abandon on dresses and jewels."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en90"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en90ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" In fact, whenever she could she liked to combine these two indulgences, with jaw-dropping results: according to Olivier Bernier, “at a time when a well-to-do noble family could live luxuriously on 30,000 livres a year,” Du Barry spent 450,000 livres on a single diamond-encrusted dress bodice."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en91"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en91ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These pretensions provided Marie Antoinette and her companions with endless amusement. On one occasion, the Comtesse de Grammont, a "), _c('em', [_vm._v("dame pour accompagner Madame la Dauphine")]), _vm._v(" who was related to Choiseul by marriage, took the merriment so far as to step deliberately on Du Barry’s train, tearing it “to atoms, [then] laughing most immoderately” with her friends."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en92"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en92ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" More frequently, the Dauphine and her clique were content to titter none too subtly behind their fans whenever Du Barry, trailed by Zamor, entered their sights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young ladies’ irreverent antics attracted the notice not just of the unhappy favorite, but of the King himself, whose intermediaries warned the Dauphine that his forbearance would not last forever. (Maria Theresa, briefed by Mercy, urged her daughter to make peace with the favorite, pleading with her at least to “say one word to her—about a dress or some bagatelle of that sort,” possibly on the grounds that at least the two adversaries had a love of pretty clothes in common."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en93"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en93ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(") But these admonitions fell on deaf ears. Marie Antoinette’s escapades with her irrepressible "), _c('em', [_vm._v("dames")]), _vm._v(" remained just about the only bright spots on her otherwise dreary social horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the months that followed her wedding, the Dauphine also sought camaraderie among the children of her female attendants. Although Versailles was not traditionally a child-friendly place, its highest-ranked princess insisted on reviving her old girlhood games with the few youngsters who did cross her path. Two of them, the five-year-old and four-year-old sons of her "), _c('em', [_vm._v("femmes de chambre")]), _vm._v(" Madame Miséry and Madame Thierry, respectively, “never left Madame the Dauphine’s apartments and caused a fair amount of disorder there”—to the chagrin of just about everyone but the Dauphine herself."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en94"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en94ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" (Even the boys’ mothers were horrified.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Homesick for her two youngest brothers, Ferdinand and Max, Marie Antoinette amused herself by watching the little fellows “stain her dresses, tear down her wall-hangings, break her furniture, and throw her apartments into complete disorder,” as Mercy wrote disapprovingly to the Empress."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en95"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en95ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" For more sisterly diversion, she took up with Madame Miséry’s twelve-year-old girl and with a lovely four-year-old daughter of still another of her women."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en96"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en96ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" Together, the three girls would kneel on the floor of the royal apartments, playing dolls for hours on end, just as Marie Antoinette had done as a child back in Austria.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v("Despite the Dauphine’s fondness for such interludes, they proved shortlived, thanks to the intervention of the Comtesse de Noailles, who did not miss a single opportunity to make the Austrian girl toe the Bourbon line and to remind her that she was, as Maria Theresa herself had put it, “a foreigner who, in every instance, [should] want absolutely to please the nation.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en97"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en97ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" The Comtesse therefore railed against the girl’s donkey-back jaunts because court protocol had no established precedent dictating how courtiers should behave “when a Dauphine of France falls off a donkey.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en98"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en98ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" Marie Antoinette found the grievance a laughable one and baptized the older woman “Madame Etiquette” to register her contempt. But a mocking nickname from a poorly behaved Hapsburg princess was hardly enough to put Madame Etiquette off her mission.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Madame de Noailles objected in particular to Marie Antoinette’s overfamiliar relationships with her staff members’ offspring. Banishing the children from the Dauphine’s quarters, the "), _c('em', [_vm._v("dame d’honneur")]), _vm._v(" announced, would reestablish the suitably dignified calm that had reigned there under the previous Dauphine, Louis Auguste’s late mother, Marie Josèphe. (This princess had showed an exemplary docility with respect to court conventions, as Madame Etiquette liked to remind her unruly charge."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en99"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en99ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(") To the Comtesse, the doll-playing was sufficiently horrifying to merit the attention of Louis XV himself. Far less stringent than his great-grandfather, Louis XIV, about matters of etiquette, the King’s first instinct was to dismiss Madame de Noailles’s complaint out of hand. Marie Antoinette was still so young; why not allow her to have some innocent fun? Besides, was it not far better for the Dauphine to busy herself with dolls than with politics?"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en100"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en100ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This rhetorical question betrayed the ever-growing influence of Madame Du Barry and her circle, who laced their criticisms of “the little redhead” with hints that she had come to court with the sole objective of establishing Austrian interests above France’s own. Compared to threats of this nature, a bit of child’s play did not at first present itself to Louis XV as cause for concern. However, as the Comtesse continued to barrage him with grievances about the Dauphine’s “careless[ness] in matters of dignity and outward appearance,” he conceded that his granddaughter-in-law must indeed find a way to rein in her “natural gaiety . . . when she is holding her court.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en101"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en101ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE SOVEREIGN’S COMMAND, WHICH MARIA THERESA FORCEFULLY REPRISED")]), _vm._v(" in her letters, did not allow Marie Antoinette much room for maneuver, as “holding her court” accounted for practically all of her time. Etiquette demanded that the Dauphine follow the same kinds of choreographed public rituals as those her husband was always trying to subvert. Beginning with "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _vm._v("her "), _c('em', [_vm._v("lever")]), _vm._v(", ending with her "), _c('em', [_vm._v("coucher")]), _vm._v(", and including just about everything in between—trips to mass, public meals, formal receptions, audiences, and visits—her day followed a strict, all-consuming schedule."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en102"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en102ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" This regimen took literally the importance of “outward appearances,” so that even the actions constituting her "), _c('em', [_vm._v("toilette")]), _vm._v(" served as a focal point for the court as a whole. “At eleven each morning,” she wrote to her mother on July 12:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("I have my hair done. Then at noon, they call in the chamber . . . and I put on my rouge and wash my hands in front of everyone "), _c('em', [_vm._v("[devant tout le monde")]), _vm._v("; also: “before the whole world”]. Then the gentlemen leave and the ladies stay, and I get dressed in front of them."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en103"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en103ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although describing one of the key features of her imprisonment in court routine, the language the Dauphine used here was deceptively neutral. Early on, Maria Theresa had warned her not to risk the expression of any personal feelings in her missives, lest unfriendly parties intercept the letters, and Marie Antoinette quickly came to share this aversion to prying eyes. (Arguably, her fears for her privacy were well founded: less than two months after her arrival, she caught the hateful Duc de La Vauguyon listening outside her bedroom door during one of Louis Auguste’s rare visits there."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en104"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en104ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(") The girl thus framed her updates in bald, uncomplaining terms that, as her mother had recommended, “all the world [again: "), _c('em', [_vm._v("tout le monde")]), _vm._v("] might read,” and which no one could turn against her."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en105"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en105ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, notwithstanding the bland way in which she described it, the ceremony of the Dauphine’s "), _c('em', [_vm._v("toilette")]), _vm._v(" was extremely arduous, for it was supposed to overlay on her person all the established, outward signs of monarchical grandeur. This, indeed, was why she had had to be a blank slate upon arriving at court: there were layers upon layers of accoutrements that she, as a Bourbon princess, had to be primed to accommodate—beginning, in her "), _c('em', [_vm._v("toilette")]), _vm._v(", with an intricate hairdo. To bring the Dauphine into conformity with court fashion, Monsieur Larsenneur, who had first waited on her in Vienna, had to tease her locks into shape by “frizzling” them with hot irons and curling papers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en106"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en106ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" He then piled them onto a scaffolded construction of wool and wire, and blew powder over the whole confection with a large instrument resembling fireplace bellows."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en107"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en107ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" While Larsenneur did this, the women of Marie Antoinette’s retinue were obliged to hold a mask over her face and a peignoir over her morning gown so that the heavy powder would not coat her skin or her clothes. The whole affair took at least an hour and represented a stunning departure from the years when an Austrian governess would simply scrape the girl’s hair back with a cloth band and call it a day. At Versailles, the Dauphine was discovering, her appearance was a collaborative "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _vm._v("effort, subject to the ministrations of many hands, and to the opinions of many people; for her image was also the image of the Bourbon clan, whose magnificence underpinned and upheld the entire social order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The application of rouge also put the Dauphine through her political paces, for it was also a highly public event, at which just about everyone with Rights of Entry to Marie Antoinette’s chambers (granted as a matter of course to people of importance at Versailles) tended to put in an appearance. In keeping with the codes of the court, the Dauphine had to extend the appropriate greeting to each person who came into her chamber while her ladies were slathering makeup onto her cheeks. Depending on the rank of the person arriving, Antonia Fraser has noted, Marie Antoinette was expected either “to nod her head or to incline her body or—most graciously of all, when faced with a prince or princess of the blood—to make as if to rise without actually doing so.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en108"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en108ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Needless to say, Madame de Noailles grilled her charge relentlessly on the subject of the various courtiers’ positions and of the type of salutation each was entitled to receive. Welcoming every spectator to her "), _c('em', [_vm._v("toilette")]), _vm._v(" with a different, intricately nuanced gesture thus required serious concentration on Marie Antoinette’s part and left her vulnerable, when she slipped up, to the criticisms of her guardian and the court as a whole. This aspect of the ceremony, too, pointed up the highly politicized nature of Marie Antoinette’s standing as a focus for “all eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logistics and politics became even more unwieldy when it came time to dress Marie Antoinette in her "), _c('em', [_vm._v("robe à la française")]), _vm._v(". Custom held that the Dauphine could reach for nothing herself—which, for instance, meant that unless Madame de Noailles, who as "), _c('em', [_vm._v("dame d’honneur")]), _vm._v(" held the privilege of handing her a glass of water, was nearby, the princess had to go thirsty. A similar logic subtended her "), _c('em', [_vm._v("toilette")]), _vm._v(", which Madame Campan described as a “masterpiece of etiquette” even by the extreme standards of Versailles:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("If the "), _c('em', [_vm._v("dame d’honneur")]), _vm._v(" and the "), _c('em', [_vm._v("dame d’atours")]), _vm._v(" were both present they performed the principal service together, aided by the "), _c('em', [_vm._v("première femme [de chambre]")]), _vm._v(" and two other women; but there were distinctions among their different roles. The "), _c('em', [_vm._v("dame d’atours")]), _vm._v(" handed [the Dauphine] her underskirt and presented her with her dress. The "), _c('em', [_vm._v("dame d’honneur")]), _vm._v(" poured out the water for [the Dauphine] to wash her hands and passed her the "), _c('em', [_vm._v("chemise")]), _vm._v(". When a princess of the blood was present, she took over this last function from the "), _c('em', [_vm._v("dame d’honneur")]), _vm._v(", who could not however hand her [the "), _c('em', [_vm._v("chemise")]), _vm._v("] directly. Rather, the "), _c('em', [_vm._v("dame d’honneur")]), _vm._v(" had to pass [the "), _c('em', [_vm._v("chemise")]), _vm._v("] back to the "), _c('em', [_vm._v("première femme")]), _vm._v(", who in turn presented it to the princess of the blood."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en109"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en109ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _vm._v("Like the carefully nuanced greetings that punctuated the application of the Dauphine’s rouge, this elaborate sequence emphasized—to her and to all other participants—the deep ceremonial and political importance with which the stylized presentation of her body was invested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The underlying political nuances of the "), _c('em', [_vm._v("toilette")]), _vm._v(" were thrown into especially strong relief whenever a noblewoman who had not been present for the beginning of the ritual entered the Dauphine’s apartments once it was already under way. On these occasions, the new arrival had to be incorporated into the process according to her place in the court pecking order. If the latecomer ranked above the princess who was on the verge of handing Marie Antoinette an article of clothing, then the latter woman was obliged to return the garment to the "), _c('em', [_vm._v("première femme de chambre")]), _vm._v(", so that the entire process might begin again. It was unthinkable that a lady of august standing could simply stand by while her social inferior usurped her right to perform the final honors in getting the Dauphine dressed. As Madame Campan averred, “All of the ladies scrupulously observed these usages, which they viewed as their [sacred] rights.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en110"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en110ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" At the same time, none of these privileged women seemed the least bit concerned that while they performed their rightful duties, Marie Antoinette herself had to stand naked in their midst for extended periods of time—“her arms crossed over her chest and looking very chilly.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en111"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en111ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On one especially cold morning, when the late entries of various countesses and duchesses caused even more than the usual number of stops and starts to her "), _c('em', [_vm._v("toilette")]), _vm._v(", Marie Antoinette abruptly gave voice to her exasperation, exclaiming, “Oh this is odious! What an inconvenience!”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en112"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en112ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" Uttered as they were in extended company, these words ruffled feathers among the Dauphine’s proud, entitled entourage, and report of them spread quickly through the palace. The Comtesse de Noailles was horrified as ever—but in this case, she had a point. Given her continued failure to conceive a child, to gain her husband’s friendship, or even to behave civilly toward the King’s mistress, Marie Antoinette’s position was precarious enough as it was. By disrupting her "), _c('em', [_vm._v("toilette")]), _vm._v(", with its emphasis on making visible the sublimity of her station, she gave the French party further rationale for claiming that as Dauphine, she was an irredeemable failure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AFTER HER INTERVIEW WITH THE DAUPHIN AT CHOISY IN JULY, DURING")]), _vm._v(" which he had pledged to live with her “in all the intimacy that their union required,” Marie Antoinette had run straight to the Aunts, to whom this information came as unwelcome news."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en113"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en113ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Like the Comte de Mercy, in whom Marie Antoinette had also confided, they suspected that if Louis Auguste "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _vm._v("came to love her, the Dauphine would “be able to dominate him completely.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en114"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en114ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" It went without saying that a baby would shore up her position—and, by extension, Choiseul’s—considerably. And so, while Mercy, Maria Theresa, and the "), _c('em', [_vm._v("choiseulistes")]), _vm._v(" rejoiced at this prospect, Mesdames took it as an impetus to nip the Archduchess’s triumph in the bud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As usual, Madame Adélaïde took the lead. Despite her portliness and her often unkempt appearance, this daughter of the King remained, as a Bourbon family friend, the Comtesse de Boigne observed, “highly preoccupied with anything pertaining to her "), _c('em', [_vm._v("toilette")]), _vm._v(" . . . [and] had an extreme need for inventiveness and luxury” in her wardrobe."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en115"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en115ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" Already it had been impressed upon the Dauphine that at the court of France, “a woman could not be seen wearing the same dress or jewels on several consecutive occasions.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en116"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en116ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" Apparently, this discovery prompted her to seek sartorial guidance from an adviser she assumed to be more sympathetic than Madame Etiquette. Madame Adélaïde readily seized the opportunity to put her newest plan into effect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The scheme drew its inspiration from Marie Antoinette’s recent clashes with the Comtesse de Noailles and targeted specifically the domain of the young princess’s "), _c('em', [_vm._v("toilette")]), _vm._v(", which, along with the codified social interactions to which it subjected the Dauphine, had the added significance of imposing on her the identifying markers of her class. The huge circles of rouge and the high, powdered coiffure she evoked in her letter to Maria Theresa did not function so much to beautify the princess—whose blooming complexion and fair hair scarcely required such embellishments—as to symbolize her royal standing. Custom identified adornments such as heavy rouge as the province of high-born ladies, just as it conferred the wearing of red-heeled shoes "), _c('em', [_vm._v("(talons rouges)")]), _vm._v(" on male grandees."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en117"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en117ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" In the case of both rouge and "), _c('em', [_vm._v("talons rouges")]), _vm._v(", the exuberant hue served to set nobles apart from their more drably attired social inferiors and to call attention to their own enviable stature."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en118"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en118ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" (One eighteenth-century Englishman visiting France took note, recalling: “The First time I saw the Ladies all rouged . . . they seem’d to me to look like a long Bed of high-colour’d full-blown Peonies in a garden.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en119"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en119ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(") By suffering to have her cheeks reddened “before the whole world,” Marie Antoinette thus repeated yet another crucial symbolic gesture: she publicly assumed the signs of aristocratic power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The whalebone stays into which the Dauphine’s attendants laced her at her "), _c('em', [_vm._v("toilette")]), _vm._v(" fell into the same important category. Like rouge, the stays emphasized her membership in the ruling caste as distinct from any other social group. A tightly corseted body evinced “the norms of stiffness and self-control” valued by aristocrats; in sharp contrast, the body of a lower-class individual, as the historian Daniel Roche has observed, tended either "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _vm._v("to be “bent by hardship and toil, or [to] enjoy a freedom unrestricted by etiquette.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en120"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en120ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" Well-born children of both sexes were therefore put into stays early—often by age two—to “prevent deformities of the skeleton” and “keep the waist under control.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en121"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en121ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" When boys reached the age of six, they traded their stays for breeches, but female aristocrats remained corseted all their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But if the whaleboned bodice was universal at Versailles, Marie Antoinette’s position required her to wear it in a particularly inflexible form known as the "), _c('em', [_vm._v("grand corps")]), _vm._v(". In the costume symbolism of the court, this was a mark of supreme distinction: France’s greatest princesses alone had the right to wear the "), _c('em', [_vm._v("grand corps")]), _vm._v(" on a regular basis."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en122"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en122ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" Other noblewomen were allowed to don it only on the day of their presentation at court (the solemn ceremony at which the scions of the aristocracy were formally “presented” to the King and Queen), and, after that, at specially designated formal functions. The Marquise de La Tour du Pin, who served as a "), _c('em', [_vm._v("dame du palais")]), _vm._v(" after Marie Antoinette’s accession, described the rarefied "), _c('em', [_vm._v("grand corps")]), _vm._v(" as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("It was a specially made corset, without shoulder straps, laced up the back, but tight enough so that the lacings, four fingers wide on the bottom, allowed for a glimpse of a "), _c('em', [_vm._v("chemise")]), _vm._v(" of such fine batiste that it would be readily apparent to everyone if one’s skin underneath was not sufficiently white. . . . The front of the corset was laced, as it were, with rows of diamonds."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en123"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en123ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Marie Antoinette’s case, whiteness of skin was ostensibly not a concern; her “lilies and roses” complexion was said to show beautifully beneath the thin "), _c('em', [_vm._v("chemise")]), _vm._v(" that peeked through her lacings. Looking good in the corset and feeling good in it were, however, two different matters entirely. The Marquise de La Tour du Pin recalled her own experience of the "), _c('em', [_vm._v("grand corps")]), _vm._v(" as “extremely bothersome and fatiguing”; indeed, even more than the regular corset, the stiff and tight-laced "), _c('em', [_vm._v("grand corps")]), _vm._v(" severely restricted its wearer’s movements, especially around the arms."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en124"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en124ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" Digesting one’s food and breathing were rendered equally challenging, and the bodice caused frequent fainting among the court’s prominent ladies, especially expectant mothers, for even pregnancy did not exempt one from the "), _c('em', [_vm._v("corps")]), _vm._v(". According to the corset’s nonnoble critics, who saw it as a badge of loathsome class vanity, other common side effects included heart palpitations, asthma, vapors, “stinking breath, consumption, and a withering rottenness.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en125"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en125ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though the Dauphine did not suffer from the worst of these symptoms, she resented the basic discomforts that the "), _c('em', [_vm._v("grand corps")]), _vm._v(" imposed. The simple "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _vm._v("corps she had grown accustomed to wearing while in Vienna was noticeably more flexible than the one she now had to endure each day at Versailles. Even her mother, who rarely acknowledged personal discomforts suffered for the sake of political glory, conceded that “those Paris-made corsets [were] far too stiff” to make for sensible wear, and offered to send Marie Antoinette some Austrian ones in their stead."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en126"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en126ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" Given that she was quite thin enough to slip into her formal gowns without the "), _c('em', [_vm._v("grand corps")]), _vm._v(", it did not take long before the Dauphine was questioning why she had to don it at all. “No one else, so far as she knew, wore such a garment [every day], so pray why should she do so?”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en127"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en127ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" Particularly in the heat of her first French summer, Marie Antoinette approached the rigid bodice more as a torture device than as an indispensable emblem of her rank."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en128"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en128ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the Dauphine’s trusted confidante, Madame Adélaïde had no trouble getting her to admit her aversion to the stays, and this became the basis for her new plan of attack. The court was of course already buzzing with stories of Marie Antoinette’s etiquette infringements; by June, just a month after her wedding, these tales had even begun to circulate in Paris, where many of the court’s denizens maintained splendid houses, and where the girl’s enemies triumphantly spread the news of her failures."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en129"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en129ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" If the Dauphine could be led to attract still more scandal to her name, through a continued eschewal of the "), _c('em', [_vm._v("grand corps")]), _vm._v(", then perhaps she could be eliminated before Louis Auguste made good on his promise to bed her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE AUNTS WASTED NO TIME IN PUTTING THIS STRATEGY INTO EFFECT")]), _vm._v(". Though as Children of France they, too, were required to wear the "), _c('em', [_vm._v("grand corps")]), _vm._v(", they abruptly stopped doing so and urged the Dauphine to follow suit. Because they were aging spinsters, however, Mesdames had the option of keeping their corsetless state hidden during public appearances. They took to “enveloping themselves right up to their chin” in billowy black taffeta capes—especially, Madame Campan noticed, whenever the King was around."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en130"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en130ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But neither Louis XV nor his courtiers paid Mesdames the same level of attention as they did Marie Antoinette, whose physical charms were expected to remain on constant display. In any event, not even the most loose-fitting taffeta cape could have protected the Dauphine from her guardian’s eagle eyes. Present whenever the princess was getting dressed, Madame de Noailles could not help but notice—and fixate on—the girl’s abandonment of the "), _c('em', [_vm._v("grand corps")]), _vm._v(". By August 4, this irregularity was sufficiently public knowledge that the Comte de Mercy felt compelled to raise it with the Empress: “The "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('em', [_vm._v("dame d’honneur")]), _vm._v(" says that there is no way of convincing Madame la Dauphine to wear a corset.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en131"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en131ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To a woman who viewed “even a pin misplaced on a court gown [as] a tragedy,” this unprecedented rejection of the corset betokened nothing short of an apocalypse."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en132"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en132ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" Madame Etiquette made it known that Marie Antoinette’s “waist [was] growing misshapen, and her right shoulder out of kilter,” a verdict that other courtiers rapidly disseminated far and wide."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en133"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en133ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" “In the palace and beyond its walls, . . . the chief topic of conversation was the awful fact . . . that one of the future queen’s shoulder blades was more protruding than the other.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en134"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en134ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" Insofar as this news seemed to reveal the Bourbon princess’s unwillingness to adapt to her role, it was received as important political gossip in other European courts. Fifteen years later, in fact, an English lord touring Marie Antoinette’s apartments after she and her family had been sent to jail asked to examine a bodice of hers that revolutionary looters had left lying on the floor. (Plate 10.) He explained to his puzzled French companions that he had long ago heard tales of the young woman’s misshapen right shoulder—attributable to her avoidance of the "), _c('em', [_vm._v("grand corps")]), _vm._v("—and was curious to see whether her bodice was padded to disguise the deficiency."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en135"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en135ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another foreigner to weigh in on the affair of the "), _c('em', [_vm._v("corps")]), _vm._v(", Maria Theresa’s friend the Countess Windischgrätz, focused less on the alignment of Marie Antoinette’s shoulders than on the general slovenliness that the missing undergarment occasioned. After her presentation at Compiègne in early August 1770, the Countess informed acquaintances in Paris, Brussels, and Vienna “that the Dauphine was "), _c('em', [_vm._v("très mal mise")]), _vm._v(" [very badly dressed] and that her figure was not good.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en136"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en136ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" Whether she knew it or not, in eschewing the corset, the princess was playing with fire.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE COMTE DE MERCY, FOR HIS PART, WAS ACUTELY AWARE OF THE DANGERS")]), _vm._v(" the girl’s conduct posed for her future at Versailles and, by extension, for the Franco-Austrian alliance. After doing some discreet detective work, he established that Madame Adélaïde and her sisters had played a major role in the trouble. Identifying them as thoroughly “dangerous people,” he notified Maria Theresa that her daughter would be far better off if she were to “behave exactly in the opposite manner to Mesdames her Aunts,” who were deliberately setting the girl on the path to her own destruction."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en137"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en137ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" This information prompted the Empress to reverse her initial view of the women as appropriate mentors for her daughter. Agreeing with Mercy about the Aunts’ perfidy, she enjoined him to save the Dauphine from their clutches: “I "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _vm._v("am counting on your prudence in advising her so that she avoids any further missteps.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en138"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en138ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To do so, however, Mercy needed to talk to Marie Antoinette in private, and that proved virtually impossible. As an ambassador to the court of France, he enjoyed Rights of Entry to the Dauphine’s chambers for ceremonies like the "), _c('em', [_vm._v("toilette")]), _vm._v(". Insofar, though, as these took place “before the whole world,” they provided him with no chance to broach such a delicate subject as the Aunts’ double-dealing. Complicating matters further, etiquette dictated that Marie Antoinette visit Mesdames’ apartments several times a day, and because she had no other friends to call on, this was one Bourbon practice the Dauphine seemed all too eager to embrace. During the court’s retreat at Compiègne, she spent most of her time with them. Whether on her long, donkey-led processions or on her recreational carriage jaunts in the forests around the château, the Dauphine was almost constantly flanked by the three older ladies."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en139"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en139ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So it was not until August 24, 1770, three weeks after he had first written to Maria Theresa about the corset problem, that Mercy managed briefly to dodge the Aunts’ blockade. With the court’s stay at Compiègne drawing to a close—preparations were being made for a short trip to Chantilly on the twenty-eighth, before the return to Versailles on the thirty-first—Mercy took advantage of the hubbub to steal a few moments alone with the Dauphine. “I begged her,” he informed the girl’s mother afterward, “to watch herself very closely” in the future."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en140"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en140ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By this point, however, the damage had largely been done. Both at Versailles and in Paris—for the French party was by no means above the "), _c('em', [_vm._v("choiseulistes")]), _vm._v("’ tactic of leaking damning gossip outside the bounds of the court—wags made clever quips about the Dauphine’s rejection of “that belt, that precious ornament,” and snickered openly about her conflicts with her guardian."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en141"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en141ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" Even the Abbé de Vermond, who disliked Bourbon etiquette for the relatively low place it assigned him in the court hierarchy, recognized the enormity of his pupil’s transgressions. The Dauphine’s “refusal of the corset [and] the disfavor of the Comtesse de Noailles,” he warned her in mid-September, had set “all of France complaining.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en142"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en142ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To savvy Maria Theresa, that the French had gone from praising her daughter’s comely, successfully Gallicized appearance to disparaging her as an unwashed, sloppy, and disrespectful foreigner could not but come as a threat to the Bourbon-Hapsburg alliance. After fielding reports from Mercy about the Dauphine’s conduct, she wrote to Marie Antoinette chiding her for “tak[ing] poor care of yourself, apparently even when it comes to cleaning your teeth; this is a key point, as is your figure, which [people say] has "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _vm._v("worsened.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en143"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en143ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" Closer to home, Madame Campan likewise discerned the political dangers that the Dauphine’s physical negligence entailed; the "), _c('em', [_vm._v("femme de chambre")]), _vm._v(" noted in horror that the stalwarts of the French party had grown so emboldened as to entertain openly “the possibility of a divorce.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en144"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en144ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, in order to justify such an extreme outcome as sending Marie Antoinette back to Vienna, her detractors would have to advance a somewhat subtle argument. Given the Dauphin’s own history of etiquette violations, they could not exactly claim that he had shunned Marie Antoinette just because she had abandoned her "), _c('em', [_vm._v("corps")]), _vm._v(". What they could and did do, though, was to keep the court and the public focused on the girl’s untamed midsection—which, in light of each of Louis Auguste’s widely publicized brush-offs, came to stand not just for diminished beauty and disrespected etiquette, but for chronic infertility as well. Maria Theresa herself adopted this line of reasoning when she wrote admonishingly to her daughter later that fall: “Reassure me about the corsets you are wearing, or else I will worry about it, for fear, as they say in German, of "), _c('em', [_vm._v("auseinandergehen, schon die Taille wie eine Frau, ohne es zu sein.”")]), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en145"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en145ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" For fear, as they say in English, of letting yourself go and gaining a fuller, more womanly waistline, "), _c('em', [_vm._v("without in fact being a wife")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More than Vermond’s solemn lectures, Mercy’s furtive hints, or the Comtesse de Noailles’s ceaseless nagging, the Empress’s German aphorism appeared to hit home. A few months into her corset embargo, the Dauphine finally seemed to grasp that she had no business claiming unprecedented freedoms for herself when she was not yet “a real dauphine.” Her relations with Louis Auguste grew steadily friendlier over the course of the autumn, as he began, despite his reticence, to “allow himself some little caresses, and one day even felt bold enough to give her a kiss.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en146"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en146ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" Yet these little signs of the Dauphin’s growing regard did little to quell the relentless gossip-mongering of his wife’s detractors. “The possibility of a divorce”—or, more precisely, an annulment, which European princes sometimes secured to rid themselves of childless wives—still lingered menacingly on the horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That fall, it became public knowledge that the Dauphin’s younger brother Provence was going to marry Marie Joséphine, a Savoyard princess, in May of the following year. Ever vigilant about possible shifts in the court’s delicate balance of power, the nobles of Versailles went into a frenzy of speculation. Would the new royal bride displace Du Barry, or the Dauphine, in the King’s affections? Would an alliance with Savoy alter in any way the administration’s stance on Austria? And, most worrisome of all from Marie "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _vm._v("Antoinette’s perspective: would Provence manage to sire a child ahead of the current heir to the throne?"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en147"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en147ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Provence—who resented the Dauphin and Dauphine for outranking him in the succession—bragged mercilessly about the sexual prowess that he, in contrast to his hapless brother, planned to display as a bridegroom. Louis Auguste was humiliated, and Marie Antoinette aghast."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en148"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en148ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" Should the Comtesse de Provence bear a child before her, the Dauphine’s own inadequacy as a consort would become more glaringly obvious than ever, and her superfluity at the court of France would be beyond question. To the extent that she allowed her waistline to grow progressively thicker “without in fact being a wife,” she was only reminding both herself and the nation of this mortifying fact. And so, in the middle of October, the Dauphine capitulated. Summoning Mercy to meet with her alone, she confessed that she had been horribly “upset by some reports about her position and her person, and she cited the question of the corset.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en149"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en149ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" From that moment on, Mercy reported, she “finally agreed to wear a corset quite regularly.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en150"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en150ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACCORDING TO MARIA THERESA’S AMBASSADOR, THE DAUPHINE’S CHANGE")]), _vm._v(" of heart led to a swift improvement in her political fortunes. On October 20, just a few weeks after she surrendered to the "), _c('em', [_vm._v("grand corps")]), _vm._v(", he informed Maria Theresa that “recently the King has increased his tenderness, his attention, and all the marks of his caring friendship for Madame la Dauphine.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en151"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en151ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" Four months later, Mercy reiterated: “His Majesty again takes a friendly tone with Madame la Dauphine and kisses her hands very often. When [she] ignores Mesdames’ advice, the King is enchanted and displays a level of tenderness that he does not show toward any of his other children.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en152"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en152ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" Unfortunately, Mercy lamented in the same dispatch, “nothing has yet come of Monsieur le Dauphin’s supposed plans to live with Madame la Dauphine in the intimacy that their union requires.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en153"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en153ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" Still, Marie Antoinette’s reinstatement in Louis XV’s good graces went some way toward fortifying her position and protecting her from the possibility of annulment or divorce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dauphine’s readoption of the corset had another, equally significant result. “Madame la Dauphine’s figure,” Mercy wrote in February 1771, “has been nicely restored by the usage of whalebone stays, and [she] now observes quite carefully all matters pertaining to grooming and dress.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en154"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en154ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" This development had the immediate advantage of silencing the slew of negative publicity the French party had generated about Marie Antoinette’s looks. No longer could Mesdames’ or Du Barry’s coteries justly impugn her "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _vm._v("appearance; her newfound scrupulousness, strict and unyielding as any "), _c('em', [_vm._v("grand corps")]), _vm._v(", placed her beyond their reproach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, disappointment among the French party did not mean unreserved happiness for Marie Antoinette, upon whom the corset affair appears to have had a sobering, if illuminating, impact. As Maria Theresa reminded her in the scandal’s aftermath, the court culture of the Bourbons was founded on a strict equivalency between symbolic glory and political strength. And because the Aunts had knowingly encouraged her to upend this equation, she must no longer look to them for assistance in honoring it.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Do not be negligent about your appearance. . . . I cannot caution you enough against letting yourself slip into the errors that the members of the French royal family have fallen into of late. They may be good and virtuous, but they have forgotten how to appear in public, how to set the tone [for the nation]. . . . I therefore beg you, both as your tender mother and as a friend, not to give in to any further shows of nonchalance about your appearance or court protocol. If you do not heed my advice, you will regret it, but it will be too late. On this point alone you must not follow your [French] family’s example. It is up to you now to set the tone at Versailles."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en155"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en155ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As was often the case, the Empress’s advice was in equal parts intimidating and constructive. Her gloomy forecast—“you will regret it, but it will be too late”—put no balm on the wounds of a girl whose recent “shows of nonchalance” had already attracted so much scandal to her name. At the same time, however, by encouraging her daughter to step to the forefront of French court life, and to do so by means of a carefully cultivated appearance, Maria Theresa gestured toward a new strategy for survival. If Marie Antoinette could not defy the exigencies of “appearance and court protocol,” perhaps she could turn them to her advantage. With Du Barry cornering the market on the King’s erotic appetites, and the future Comtesse de Provence poised to unseat her as the mother of the next Bourbon heir, it behooved the Dauphine to find another way of shoring up her tenuous position at Versailles. And Versailles was a place where, as everything from the corset hullabaloo to the publicity and ceremony of her daily "), _c('em', [_vm._v("toilette")]), _vm._v(" had taught her, matters of costume were monitored as closely and taken as seriously as royal sex (whether recreational or dynastic).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This being the case, it seems not inappropriate to suggest that a heightened attention to the styling of her body presented itself to Marie Antoinette at this stage as a viable, alternative path to political security. It was her cross to bear that her husband’s embargo on the marriage bed continued to disqualify her "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _vm._v("as “a real dauphine.” But with a little more savvy about the way she looked and dressed, she could at least do her best to "), _c('em', [_vm._v("resemble")]), _vm._v(" a real dauphine—to appear, as one courtier later expressed it, “as if she had been born for the throne.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch03en156"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en156ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" In a court where appearances were indeed everything, perhaps the appearance of majesty would suffice.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81bd38f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter003.vue
// module id = 93
// module chunks = 0